import lodashGet from 'lodash/fp/get';
import lodashKeyBy from 'lodash/fp/keyBy';
import typeCheck from 'common/util/typeCheck';

import {
  TENANT_ALERT_SERVICE_LIST,
  TENANT_ALERT_APPLICATION_STATUS_ERROR,
  TENANT_ALERT_APPLICATION_STATUS_PROCESSING,
  TENANT_ALERT_APPLICATION_STATUS_COMPLETED,
} from 'common/tenantAlertConstants';

const keyByServiceId = lodashKeyBy('service_id');

export function getTenantAlertApplicationReports({ tenantAlertApplication, tenantAlertServiceId }) {
  typeCheck('tenantAlertApplication::NonEmptyObject', tenantAlertApplication);

  const reportsByServiceId = keyByServiceId(lodashGet('reports', tenantAlertApplication) || []);
  const reports = TENANT_ALERT_SERVICE_LIST.map(
    (serviceId) => reportsByServiceId[serviceId],
  ).filter((report) => report);

  if (tenantAlertServiceId) {
    return reports.filter((report) => report.service_id === `${tenantAlertServiceId}`);
  }

  return reports;
}

export function getCreditScoreStatus({ tenantAlertReport }) {
  if (!tenantAlertReport) {
    return 'Not Ran';
  }

  switch (tenantAlertReport.tenantAlertApplicationStatus) {
    case TENANT_ALERT_APPLICATION_STATUS_ERROR:
      return 'Auto-Run Failed';
    case TENANT_ALERT_APPLICATION_STATUS_PROCESSING:
      return 'Processing';
    case TENANT_ALERT_APPLICATION_STATUS_COMPLETED: {
      if (tenantAlertReport.noCreditReport) {
        return 'Invalid';
      }
      if (tenantAlertReport.creditScore === null) {
        return 'No Credit';
      }
      return tenantAlertReport.creditScore;
    }
  }
}
